<template>
  <div class="m-confirmation">
    <input type="checkbox" @change="doToggle" />
    <label
      @click="doToggle"
      :class="{ checked: value, 'm-confirmation__label': true }"
    >
      {{ label }}
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: "OQCheckbox",
  props: ["label", "value"],
  methods: {
    doToggle() {
      this.$emit("input", !this.value);
    },
  },
};
</script>

<style scoped lang="scss">
.m-confirmation label.checked:after {
  content: "";
}
.m-confirmation__label {
  margin: 24px 16px;
}
</style>
